import { Card, CardBody, Container } from "reactstrap";

interface Props {
    groupName: string;
}

const steps = (groupName: string) => [
    {
        title: "Join the Group",
        description: `Become part of the ${groupName} buying group and connect with students who share the same goal.`,
    },
    {
        title: "Grow the Group",
        description:
            "As more students join, the group's bargaining power increases, leading to stronger negotiating leverage.",
    },
    {
        title: "Collect Offers",
        description:
            "Students and the PriceWorth coordinator gather quotations, scholarships, and exclusive offers from multiple coaching institutes.",
    },
    {
        title: "Compare & Discuss",
        description:
            "Evaluate institutes based on fees, faculty, infrastructure, study materials, results, hostel facilities, scholarships, and student reviews.",
    },
    {
        title: "Choose the Best Deal",
        description:
            "The group reviews every offer together and selects the institute that provides the best overall value.",
    },
    {
        title: "Final Enrollment",
        description:
            "Students enroll using the negotiated group offer and enjoy better pricing and exclusive benefits.",
    },
];

const HowItWorks = ({ groupName }: Props) => {
    return (
        <Container className="py-5" style={{ maxWidth: "900px" }}>
            <div className="text-center mb-5">
                <h2 className="fw-bold">How It Works</h2>
                <p className="text-muted">
                    A simple step-by-step process to help every student secure the best
                    coaching institute at the best possible price.
                </p>
            </div>

            {steps(groupName).map((step, index) => (
                <div className="d-flex mb-4" key={index}>
                    {/* Left Timeline */}
                    <div
                        className="d-flex flex-column align-items-center me-4"
                        style={{ minWidth: "50px" }}
                    >
                        <div
                            className="rounded-circle bg-primary text-white fw-bold d-flex justify-content-center align-items-center"
                            style={{
                                width: "42px",
                                height: "42px",
                                fontSize: "16px",
                            }}
                        >
                            {index + 1}
                        </div>

                        {index !== steps(groupName).length - 1 && (
                            <div
                                style={{
                                    width: "2px",
                                    flex: 1,
                                    background: "#dee2e6",
                                    minHeight: "55px",
                                }}
                            />
                        )}
                    </div>

                    {/* Content */}
                    <Card className="border-0 shadow-sm rounded-4 flex-grow-1">
                        <CardBody>
                            <h5 className="fw-bold mb-2">{step.title}</h5>
                            <p className="text-muted mb-0" style={{ lineHeight: "1.7" }}>
                                {step.description}
                            </p>
                        </CardBody>
                    </Card>
                </div>
            ))}
        </Container>
    );
};

export default HowItWorks;